import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        videoId: String,
    };

    connect() {
        setTimeout(() => {
            let watchedIds = window.getCookie('lastWatchedVideoIds');
            if (watchedIds === '') {
                watchedIds = [this.videoIdValue];
                window.setCookie('lastWatchedVideoIds', JSON.stringify(watchedIds), 180);
            } else {
                try {
                    watchedIds = JSON.parse(watchedIds);
                    if (watchedIds.indexOf(this.videoIdValue) === -1) {
                        watchedIds.push(this.videoIdValue);
                    }
                    if (watchedIds.length > 10) {
                        watchedIds.shift();
                    }
                    window.setCookie('lastWatchedVideoIds', JSON.stringify(watchedIds), 180);
                } catch (e) {
                    // json was invalid
                    console.warn('Invalid json in cookie');
                    window.setCookie('lastWatchedVideoIds', JSON.stringify([]), 180);
                }
            }
        }, 5000);
    }
}
